"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const is_array_1 = tslib_1.__importDefault(require("./is-array"));
const recursive_error_1 = tslib_1.__importDefault(require("./recursive-error"));
/**
 * @category High Order Guard
 * @return a `Guard` that checks if the values of the tuple passed respect the types of the guards passed
 * @throws {RecursiveError} When calling the `self` guard in the callback
 * @example
 * ```typescript
 *   const isPersonTuple = TupleOf([isString, isNumber]);
 * ```
 * @example
 * ```typescript
 *   type Person = [string, number, Person | null];
 *   const isPersonTuple = TupleOf<Person>((self) => [
 *     isString,
 *     isNumber,
 *     OneOf([self, isNull]),
 *   ]);
 * ```
 */
const TupleOf = (guards) => {
    const isTupleOf = (tuple) => {
        return ((0, is_array_1.default)(tuple) &&
            tuple.length <= generatedGuards.length &&
            generatedGuards.every((guard, i) => (guard.optional && tuple[i] === undefined) || guard(tuple[i])));
    };
    const generatedGuards = recursive_error_1.default.assert((forbidCall) => typeof guards === "function" ? guards(forbidCall(isTupleOf)) : guards);
    const optionalBoundary = generatedGuards.reduceRight((i, guard, j) => (guard.optional ? j : i), generatedGuards.length);
    const hasRequiredAfterBoundary = generatedGuards.some(({ optional }, j) => optional ? j < optionalBoundary : j >= optionalBoundary);
    if (hasRequiredAfterBoundary)
        throw new TypeError("A required guard cannot follow an optional guard");
    return isTupleOf;
};
exports.default = TupleOf;
